<mat-button-toggle-group class="content-switcher max-width" *ngIf="!event.boEvent"
                         [(ngModel)]="selectedView" (ngModelChange)="handleViewSwitch()">
  <mat-button-toggle [value]="viewType.VIEW_SECTORS" [disabled]="enabledSectorIds.length <= 1">
    {{'general.api_sales_select_sector' | translate}}
  </mat-button-toggle>
  <mat-button-toggle [value]="viewType.VIEW_TICKETS" [disabled]="!hasSelectedSection">
    {{'general.api_sales_select_ticket' | translate}}
  </mat-button-toggle>
</mat-button-toggle-group>
<app-promocode *ngIf="showPromocode"
               [service]="cartService" [eventIds]="[event.eventId]" [selfService]="event.boEvent"
               [eventPricing]="cartService.eventPricing"
               (promocodeUpdated)="promocodeChanged.emit()"></app-promocode>
